<template>
  <v-container fluid>
    <h3 class="mb-5">{{ title }}</h3>
    <div style="display: flex">
      <div style="flex: 1; margin-right: 10px; border: 1px solid #ccc; padding: 10px;">
        <h4 class="pb-3" v-if="availableTitle">{{ availableTitle }}</h4>
        <v-text-field
          v-model="availableSearchTerm"
          label="Ieškoti"
          class="mb-2"
          dense
          outlined
        ></v-text-field>
        <ul class="no-bullets scrollable-list">
          <li
            v-for="item in filteredAvailableItems"
            :key="item[itemKey]"
            style="display: flex; align-items: center"
          >
            <v-btn icon @click="moveToSelected(item)" title="Pridėti">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <span class="pl-5">{{ item[itemName] }}</span>
          </li>
        </ul>
      </div>
      <div style="flex: 1; border: 1px solid #ccc; padding: 10px">
        <h4 class="pb-3" v-if="selectedTitle">{{ selectedTitle }}</h4>
        <v-text-field
          v-model="selectedSearchTerm"
          label="Ieškoti"
          class="mb-2"
          dense
          outlined
        ></v-text-field>
        <ul class="no-bullets scrollable-list">
          <li
            v-for="selectedValue in filteredSelectedItems"
            :key="selectedValue"
            style="display: flex; align-items: center"
          >
            <v-btn
              icon
              @click="moveToAvailable(displayedSelectedItemsMap[selectedValue])"
              title="Pašalinti"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <span class="pl-5">
              {{ displayedSelectedItemsMap[selectedValue] ? displayedSelectedItemsMap[selectedValue][itemName] : 'N/A' }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    elKey: {
      type: String
    },
    title: {
      type: String,
      default: 'Item List Transfer',
    },
    availableItems: {
      type: Array,
      required: true,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    availableTitle: {
      type: String,
      required: false
    },
    selectedTitle: {
      type: String,
      required: false
    },
    itemKey: {
      type: String,
      default: 'id',
    },
    itemName: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      availableSearchTerm: '',
      selectedSearchTerm: '',
    };
  },
  computed: {
    filteredAvailableItems() {
      const searchTerm = this.availableSearchTerm.toLowerCase();
      return this.availableItems.filter(item =>
        !this.selectedItems.includes(item[this.itemKey]) &&
        (item[this.itemName] && String(item[this.itemName]).toLowerCase().includes(searchTerm) ||
         item[this.itemKey] !== null && String(item[this.itemKey]).toLowerCase().includes(searchTerm))
      );
    },
    displayedSelectedItemsMap() {
      return this.availableItems.reduce((acc, item) => {
        if (this.selectedItems.includes(item[this.itemKey])) {
          acc[item[this.itemKey]] = item;
        }
        return acc;
      }, {});
    },
    filteredSelectedItems() {
      const searchTerm = this.selectedSearchTerm.toLowerCase();
      return this.selectedItems.filter(selectedValue => {
        const item = this.displayedSelectedItemsMap[selectedValue];
        return item && (item[this.itemName] && String(item[this.itemName]).toLowerCase().includes(searchTerm) ||
                       item[this.itemKey] !== null && String(item[this.itemKey]).toLowerCase().includes(searchTerm));
      });
    },
  },
  methods: {
    moveToSelected(item) {
      this.$emit('move-to-selected', item, this.elKey);
    },
    moveToAvailable(itemToRemove) {
      this.$emit('move-to-available', itemToRemove, this.elKey);
    }
  },
}
</script>

<style scoped>
.no-bullets {
  list-style-type: none;
  padding: 0;
}

.no-bullets li {
  padding: 3px 0;
  border-bottom: 1px solid #eee;
}

.no-bullets li:last-child {
  border-bottom: none;
}

.v-icon:first-child {
  cursor: default; /* Make the leading icon non-interactive */
}

button {
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  cursor: pointer;
  display: flex; /* Align icon in button */
  align-items: center;
  justify-content: center;
  min-width: 20px; /* Ensure button has some width */
  height: 20px; /* Ensure button has some height */
}

button:hover {
  background-color: #e0e0e0;
}

.scrollable-list {
  max-height: 300px; /* Adjust this value to your desired maximum height */
  overflow-y: auto;
}
</style>
